// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"242cfeb2","453":"15661725","732":"d1dd05e3","977":"f2034939"}[chunkId] + ".chunk.js";
};